import { Box } from "@mui/material"
import { Preuve } from "./DataTypes"

interface PreuveSelectorProps{
    name: Preuve,
    addRemovePreuve: (val: Preuve, find?: boolean) => void,
    preuvesTrouvees: Array<Preuve>
    preuvesRejected: Array<Preuve>
}

const PreuveSelector = (props: PreuveSelectorProps  ) => {

    let color = props.preuvesTrouvees.some(x => x === props.name) ? "green" : props.preuvesRejected.some(x => x === props.name) ? "red" : "white"
    return <Box textAlign={"center"} 
    width={"100px"}
    border={"solid 1px " + color}
    borderRadius={"20px"}
    margin={"5px"}
                alignItems={"center"} 
                onClick={() => props.addRemovePreuve(props.name, true)} 
                onContextMenu={(e) => {e.preventDefault(); props.addRemovePreuve(props.name, false);}} 
                sx={{ cursor: "pointer",  color: color, textDecoration: props.preuvesRejected.some(x => x === props.name) ? "line-through" : ""}}>
                    {props.name}
            </Box>
}

export default PreuveSelector